<template>
    <hero-page></hero-page>
    <link-page></link-page>
    <video-page></video-page>
    <follow-us></follow-us>
</template>

<script>
import HeroPage from "./HeroPage.vue";
import LinkPage from "./LinkPage.vue";
import VideoPage from "./VideoPage.vue";
import FollowUs from "./FollowUs.vue";
export default {
  components: { HeroPage, LinkPage, VideoPage, FollowUs },

};
</script>
